let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("kNFvF"), load("bWP0X")]).then(() => parcelRequire('2555l'));